import React from "react";
import { ErrorMessage } from "formik";

type ErrorComponentProps = {
  name: string;
  className?: string;
  component?: keyof JSX.IntrinsicElements;
};

const ErrorComponent: React.FC<ErrorComponentProps> = ({
  name,
  className = "invalid-feedback d-block text-danger",
  component = "div",
}) => {
  return (
    <ErrorMessage name={name}>
      {(msg) => React.createElement(component, { className }, msg)}
    </ErrorMessage>
  );
};

export default ErrorComponent;
